type DiscoverRowContentKeyRow = { status: "success"; items: readonly unknown[] } | { status: "idle" | "queued" | "loading" | "error" | "empty" };
type ReadDiscoverRowContentKeyParameters = {
  row?: DiscoverRowContentKeyRow;
  skeletonCount: number;
};

const readDiscoverRowContentKey = ({ row, skeletonCount }: ReadDiscoverRowContentKeyParameters): string => {
  if (row?.status === "success") {
    return `success:${row.items.length}`;
  }

  if (row?.status === "error") {
    return "error";
  }

  if (row?.status === "empty") {
    return "empty";
  }

  return `loading:${skeletonCount}`;
};

export default readDiscoverRowContentKey;
